import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
      class: "button is-primary fullwidth-mobile",
      disabled: !_ctx.isNextDisabled
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("span", null, "Next Question", -1)
    ]))], 8, _hoisted_2)
  ]))
}